export async function makeApiRequest(url, formData) {
  try {
    const method = (Object.keys(formData || {}).length > 0 ? "POST" : "GET");

    let fetchData = {
      method,
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (method == "POST") {
      fetchData.body = JSON.stringify(formData);
    }

    const response = await fetch(url, fetchData);

    // Check if response is JSON
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || `Request failed with status ${response.status}`);
      }
      
      return data;
    } else {
      // If not JSON, throw error
      throw new Error(`Unexpected response format: ${contentType}`);
    }
  } catch (error) {
    console.error("API Request Error:", error);
    throw error; // Re-throw to let calling code handle it
  }
}
